<template>
  <WdwDynbox
    ref="documentDiscussionRef"
    title="Dokumentkommentierung"
    :minimize="false"
    :config="{ showControls: false }"
  >
    <template v-if="toggle && currentComponent">
      <Navigation
        :previousTopicAvailable="topicIndex > 0"
        :nextTopicAvailable="topicIndex < topics.length - 1"
        :canJumpToTop="false"
        @previousTopic="showPrevious"
        @nextTopic="showNext"
        @listTopics="toggleTopicList"
      />
    </template>
    <!-- {{ currentComponent.name }} -->
    <KeepAlive>
      <component
        :is="currentComponent.name"
        :topic="currentComponent.topic"
        :topics="topics"
        @toggleTopic="toggleTopic"
      ></component>
    </KeepAlive>
    <template v-if="toggle && currentComponent">
      <Navigation
        :previousTopicAvailable="topicIndex > 0"
        :nextTopicAvailable="topicIndex < topics.length - 1"
        :canJumpToTop="true"
        @previousTopic="showPrevious"
        @nextTopic="showNext"
        @listTopics="toggleTopicList"
        @jumpToTop="scrollToTop"
      />
    </template>
  </WdwDynbox>
</template>

<script>
import { defineComponent, onBeforeMount, computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { domainStore } from '@/store/domain-store';
import { projectStore } from '@/store/project-store';
import { userStore } from '@/store/user-store';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import SingleTopic from './SingleTopic.vue';
import TopicList from './TopicList.vue';
import useHashParams from '@/composables/general/useHashParams';
import Navigation from '@/components/document_discussion/Navigation.vue';
import useAuthentication from '@/composables/user/useAuthentication';

export default defineComponent({
  name: 'DocumentDiscussion',
  components: {
    SingleTopic,
    TopicList,
    WdwDynbox,
    Navigation,
  },
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    projectid: {
      type: Number,
      required: true,
    },
    lang: {
      type: String,
      required: false,
      default: 'de',
    },
  },
  setup(props) {
    const { getVirtualUser } = useAuthentication();
    const route = useRoute();
    const { setHashParams, deleteHashParams } = useHashParams(route);
    const toggle = ref(false);
    const currentComponent = ref({
      name: 'TopicList',
      topic: {},
    });

    const topicIndex = ref(0);
    const documentDiscussionRef = ref(null);
    const domain = computed(() => {
      return domainStore.getState().domain;
    });
    const topics = computed(() => {
      return projectStore.getState().topics;
    });
    function toggleTopic(topic, index) {
      currentComponent.value.topic = topic;
      currentComponent.value.name = 'SingleTopic';
      topicIndex.value = index;
      setHashParams({ topic_id: topic.id });
      toggle.value = true;
    }
    function toggleTopicList() {
      toggle.value = false;
      currentComponent.value.name = 'TopicList';
      deleteHashParams(['topic_id']);
    }
    function showNext() {
      const topic_id = currentComponent.value.topic.id;
      topicIndex.value =
        topics.value
          .map(item => {
            return item.id;
          })
          .indexOf(topic_id) + 1;
      const topic = topics.value.at(topicIndex.value);
      //More Type checking :') '
      if (topic) {
        currentComponent.value.topic = topic;
      }
      setHashParams({ topic_id: currentComponent.value.topic.id });
    }
    function showPrevious() {
      const topic_id = currentComponent.value.topic.id;
      topicIndex.value =
        topics.value
          .map(item => {
            return item.id;
          })
          .indexOf(topic_id) - 1;
      const topic = topics.value.at(topicIndex.value);
      if (topic) {
        currentComponent.value.topic = topic;
      }
      setHashParams({ topic_id: currentComponent.value.topic.id });
    }
    function scrollToTop() {
      const top = documentDiscussionRef.value.offsetTop;
      window.scrollTo(0, top);
    }

    onBeforeMount(() => {
      domainStore.initDomain(props.domainid, props.lang);
      projectStore.setProjectId(props.projectid);
    });

    watch(
      () => projectStore.getState().project,
      (project, oldProject) => {
        if (!userStore.getState().authToken && process.env.VUE_APP_ENABLE_VIRTUAL_USER) {
          // try to init/get virtual user for eventual anonymous votes/comments/thoughts
          getVirtualUser()
            .then(success => {
              console.log('initialized virtual user');
            })
            .catch(e => {
              console.log('error getting virtual user');
            });
        }
      }
    );

    // Wacthes the initial loading of a topic
    watch(route, () => {
      if (
        route.query.topic_id &&
        !Array.isArray(route.query.topic_id) &&
        !Object.keys(currentComponent.value.topic).length
      ) {
        const topicid = parseInt(route.query.topic_id);
        projectStore.fetchTopic(topicid).then(res => {
          currentComponent.value.topic = res;
          currentComponent.value.name = 'SingleTopic';
          toggle.value = true;
          topicIndex.value = topics.value
            .map(item => {
              return item.id;
            })
            .indexOf(topicid);
        });
      }
    });
    return {
      domain,
      topics,
      currentComponent,
      toggle,
      topicIndex,
      documentDiscussionRef,
      showNext,
      showPrevious,
      toggleTopic,
      toggleTopicList,
      scrollToTop,
    };
  },
});
</script>
